import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { LandingService } from '../../services/landing.service';
import { IProduct } from '../../../shared/interfaces/IProduct';

declare var grecaptcha: any;
@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss'],
})
export class ContactPageComponent implements OnInit {
  @ViewChild('contactForm') contactForm!: NgForm;

  motivoConsulta: string;
  nombre: string;
  apellidos: string;
  email: string;
  telefono: string;
  mensaje: string;
  isLoading = false;
  selectedProducts: string[] = [];
  products: IProduct[] = [];
  loadingProducts = false;

  // Anti-spam fields
  honeypot: string = ''; // Campo trampa para bots
  formStartTime: number; // Tiempo de inicio del formulario
  spamError: string = ''; // Mensaje de error de spam
  recaptchaSiteKey = '6Le8iEosAAAAABrD6K8FgUOa-9NfgFm-UbEsXSox';

  constructor(
    private http: HttpClient,
    private landingService: LandingService
  ) {}

  questionSelected = 0;
  threadSelected = -1;
  reasons = [
    {
      id: 1,
      reason: 'Suscripciones',
    },
    {
      id: 2,
      reason: 'Consulta General',
    },
    {
      id: 3,
      reason: 'Productos',
    },
    {
      id: 4,
      reason: 'Mudanzas',
    },
  ];

  options = [
    {
      name: 'Instalación',
      faqs: [
        {
          question: '¿Cómo agendo la instalación?',
          answer:
            'Una vez finalizado el proceso de suscripción en línea, un representante se contactará para que selecciones el día y hora que mejor te convengan.',
          open: false,
        },
        {
          question:
            '¿Cuánto tiempo tarda el experto Everfull en realizar la instalación?',
          answer:
            'Debido a la alta demanda de suscripciones, el tiempo aproximado de instalación podría ser de 2 semanas aproximadamente a partir del momento en que estés realizando la agenda de tu cita, agradecemos tu paciencia y comprensión.',
          open: false,
        },
        {
          question:
            '¿Qué pasa con la instalación si donde vivo alquilo y no quiero tener problemas con el propietario?',
          answer:
            'No te preocupes, nuestro experto Everfull instalará el dispenser de una manera no intrusiva, es decir al momento de la instalación nuestro experto Everfull te explicará la forma como será instalado, dependiendo del equipo que elijas es la forma de instalación. Si decidís mudarte, tenés un cambio de domicilio al año sin costo y podrás seguir disfrutando Everfull en tu nuevo hogar.',
          open: false,
        },
        {
          question:
            '¿Qué pasa si ya realicé mi cita de instalación, la puedo cambiar?',
          answer:
            'Claro, comunícate con nuestro Centro de Atención Telefónica al 0800-220-AGUA (2482). Es necesario que te comuniques con al menos 3 días hábiles antes de la cita previamente programada para reagendar tu cita de instalación.',
          open: false,
        },
        {
          question: '¿Cómo es el proceso de instalación de Everfull?',
          answer:
            'De acuerdo con tu código postal te recomendamos la tecnología más conveniente que garantice la calidad del agua para tomar. Si tu zona requiere la instalación de un equipo de ósmosis inversa también se requiere una toma de electricidad cercana. Para un mejor entendimiento puedes preguntar nuestros asesores a través de WhatsApp',
          open: false,
        },
        {
          question: '¿Qué incluye la instalación?',
          answer: `La instalación cuenta con:
> El equipo dispenser de tu preferencia con instalación.
> Conexiones y manguera necesaria de 1.50 metros, siempre que se cumplan con los requisitos básicos de instalación para no generar un trabajo adicional.
> Conexión eléctrica.`,
          open: false,
        },
        {
          question:
            '¿Se puede instalar el dispenser en otra parte que no sea la cocina?',
          answer:
            'Sí, se puede instalar en cualquier lugar que tenga las especificaciones necesarias exceptuando espacios exteriores.',
          open: false,
        },
      ],
    },
    {
      name: 'Formas de contacto',
      faqs: [
        {
          question: '¿Cómo me puedo contactar para contratar el servicio?',
          answer:
            'Podés realizar la auto gestión a través de esta página ahorrando tiempo en el momento que desees. Además, podés contactarte con el sector de ventas a través de ventas@Everfull.com.ar, por whatsapp o al número que aparece en Contacto ',
          open: false,
        },
        {
          question:
            '¿Cómo me contacto si ya soy cliente y quiero adquirir un nuevo producto?',
          answer:
            'Puedes solicitar el nuevo equipo a través de Mi Everfull o contactarte a través de ventas@Everfull o al número que aparece en Contacto',
          open: false,
        },
        {
          question: '¿Cómo puedo contactarme con el servicio técnico?',
          answer:
            'Trabajamos por brindarte nuestro mejor servicio y por eso, podés contactarte con nuestro servicio técnico a través del formulario de contacto o a travez de Whatsapp',
          open: false,
        },
        {
          question: '¿Me puedo contactar a través de WhatsApp?',
          answer:
            'Por supuesto, haz click en el icono que se encuentra en la parte de abajo a la derecha.',
          open: false,
        },
      ],
    },
    {
      name: 'Cambio de domicilio',
      faqs: [
        {
          question: '¿Qué pasa si cambio de domicilio?',
          answer:
            'Nuestro equipo te acompañará y realizará la mudanza del equipo.',
          open: false,
        },
        {
          question: '¿Tiene algún costo el cambio de domicilio?',
          answer:
            'No tiene costo, junto con tu suscripción podrás realizar un cambio de domicilio por año sin ningún cargo extra.',
          open: false,
        },
        {
          question: '¿Cómo gestiono la mudanza?',
          answer:
            'Podrás comunicarte con Atención al cliente al número 0800-220-AGUA (2482) y coordinar un día y horario para realizar el cambio de domicilio. Considerá comunicarte con por lo menos 7 días de anticipación.',
          open: false,
        },
      ],
    },
    {
      name: 'Promociones',
      faqs: [
        {
          question: '¿Para qué sirven los puntos?',
          answer:
            'Con los puntos Everfull podrás recibir descuentos en tu suscripción',
          open: false,
        },
        {
          question: '¿Cómo consigo puntos?',
          answer:
            'Tus puntos se suman por pagos a tiempo y no tener deudas, tambien si tenes referidos',
          open: false,
        },
        {
          question:
            '¿Para qué sirve el código de recomendación y cómo se cuál es el mio?',
          answer:
            'Con el código de recomendación podrás enviarselo a tus conocidos y obtener beneficios por cada uno que se suscriba. Además, ellos tendrán una bonificación en su nueva suscripción. Podrás conocer tu código de recomendación en "Mi Perfil" una vez que crees tu cuenta.',
          open: false,
        },
      ],
    },
  ];

  ngOnInit(): void {
    this.gotoTop();
    this.loadProducts();
    this.formStartTime = Date.now(); // Registrar tiempo de inicio
  }

  loadProducts() {
    this.loadingProducts = true;
    this.landingService.getProducts(null).subscribe(
      (products: IProduct[]) => {
        this.products = products.map((product) => ({
          ...product,
          imageUrl: product.galeries?.[0]?.file_name || 'assets/logo-dark.png',
        }));
        this.loadingProducts = false;
      },
      (error) => {
        console.error('Error loading products:', error);
        this.loadingProducts = false;
      }
    );
  }

  // Convert newline characters to <br/> for safe HTML rendering in template
  getAnswerHtml(answer: string): string {
    if (!answer) {
      return '';
    }
    return answer.replace(/\n/g, '<br/>');
  }

  mensajeExito: string = '';

  onSubmit() {
    // Limpiar mensaje de error previo
    this.spamError = '';

    // VALIDACIÓN 1: Campo honeypot - si está lleno, es un bot
    if (this.honeypot && this.honeypot.trim() !== '') {
      console.warn('Spam detectado: honeypot completado');
      this.spamError =
        'Error al enviar el formulario. Por favor, intente nuevamente.';
      return;
    }

    // VALIDACIÓN 2: Tiempo mínimo - un humano tarda al menos 3 segundos
    const timeElapsed = (Date.now() - this.formStartTime) / 1000;
    if (timeElapsed < 3) {
      console.warn('Spam detectado: formulario enviado demasiado rápido');
      this.spamError = 'Por favor, complete el formulario con más cuidado.';
      return;
    }

    // VALIDACIÓN 3: Detectar patrones sospechosos en nombre y apellidos
    if (
      this.isSuspiciousText(this.nombre) ||
      this.isSuspiciousText(this.apellidos)
    ) {
      console.warn('Spam detectado: texto sospechoso en nombre/apellidos');
      this.spamError = 'Por favor, ingrese un nombre y apellidos válidos.';
      return;
    }

    // VALIDACIÓN 4: Detectar patrones sospechosos en el mensaje
    if (this.isSuspiciousText(this.mensaje)) {
      console.warn('Spam detectado: texto sospechoso en mensaje');
      this.spamError = 'Por favor, ingrese un mensaje válido.';
      return;
    }

    // VALIDACIÓN 5: Verificar que el email no contenga patrones sospechosos
    if (this.isSuspiciousEmail(this.email)) {
      console.warn('Spam detectado: email sospechoso');
      this.spamError = 'Por favor, ingrese un correo electrónico válido.';
      return;
    }

    this.isLoading = true;

    // Ejecutar reCAPTCHA v3 y obtener token
    this.executeRecaptcha();
  }

  // Ejecutar reCAPTCHA v3 y obtener token
  executeRecaptcha() {
    if (typeof grecaptcha === 'undefined') {
      console.error('reCAPTCHA no está cargado');
      this.spamError = 'Error al verificar. Por favor, recargue la página.';
      this.isLoading = false;
      return;
    }

    grecaptcha.ready(() => {
      grecaptcha
        .execute(this.recaptchaSiteKey, { action: 'contact_form' })
        .then((token: string) => {
          this.sendContactForm(token);
        })
        .catch((error: any) => {
          console.error('Error al ejecutar reCAPTCHA:', error);
          this.spamError = 'Error al verificar. Por favor, intente nuevamente.';
          this.isLoading = false;
        });
    });
  }

  // Enviar formulario con token de reCAPTCHA
  sendContactForm(recaptchaToken: string) {
    // Si el motivo es "Productos" y hay productos seleccionados, agregarlos al mensaje
    let finalMessage = this.mensaje;
    if (
      this.motivoConsulta === 'Productos' &&
      this.selectedProducts.length > 0
    ) {
      finalMessage +=
        '\n\nProductos de interés: ' + this.selectedProducts.join(', ');
    }

    const params = new HttpParams()
      .set('motivo', this.motivoConsulta)
      .set('nombre', this.nombre)
      .set('apellidos', this.apellidos)
      .set('email', this.email)
      .set('telefono', this.telefono)
      .set('mensaje', finalMessage)
      .set('company_id', '4')
      .set('recaptcha_token', recaptchaToken); // Agregar token de reCAPTCHA

    interface ApiResponse {
      message: string;
    }
    const apiUrl = environment.apiUrl;

    this.http
      .post<ApiResponse>(`${apiUrl}contact/send`, null, { params: params })
      .subscribe(
        (response) => {
          console.log('Enviado con éxito', response);
          this.mensajeExito = response.message;
          setTimeout(() => (this.mensajeExito = ''), 5000);
          this.resetForm();
          // Reset form validation state
          if (this.contactForm) {
            this.contactForm.resetForm();
          }
          this.isLoading = false;
        },
        (error) => {
          console.error('Error al enviar', error);
          if (
            error.status === 400 &&
            error.error?.message === 'Verificación de seguridad fallida'
          ) {
            // Error de reCAPTCHA del backend
            this.spamError =
              'No se pudo verificar su identidad. Si está usando localhost, esto es normal en desarrollo. En producción funcionará correctamente.';
          } else if (error.error?.message) {
            this.spamError = error.error.message;
          } else {
            this.spamError =
              'Error al enviar el mensaje. Por favor, intente nuevamente.';
          }
          this.isLoading = false;
        }
      );
  }

  resetForm() {
    this.motivoConsulta = '';
    this.nombre = '';
    this.apellidos = '';
    this.email = '';
    this.telefono = '';
    this.mensaje = '';
    this.selectedProducts = [];
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  toggleThread(index: number) {
    this.threadSelected = this.threadSelected === index ? -1 : index;
  }

  toggleProductSelection(productName: string) {
    const index = this.selectedProducts.indexOf(productName);
    if (index > -1) {
      this.selectedProducts.splice(index, 1);
    } else {
      this.selectedProducts.push(productName);
    }
  }

  isProductSelected(productName: string): boolean {
    return this.selectedProducts.includes(productName);
  }

  // Detectar texto sospechoso (patrones aleatorios, muchas consonantes seguidas, etc.)
  private isSuspiciousText(text: string): boolean {
    if (!text || text.trim().length === 0) {
      return false;
    }

    const cleanText = text.trim();
    const letterCount = (cleanText.match(/[a-zA-Z]/g) || []).length;

    // Solo validar si tiene al menos 5 letras
    if (letterCount < 5) {
      return false;
    }

    // PATRÓN 1: Más de 3 consonantes seguidas (detecta texto aleatorio)
    const consecutiveConsonants =
      /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]{4,}/;
    if (consecutiveConsonants.test(cleanText)) {
      return true;
    }

    // PATRÓN 2: Más de 2 caracteres idénticos repetidos seguidos (aaa, lll, etc)
    const repeatedChars = /(.)\1{2,}/;
    if (repeatedChars.test(cleanText)) {
      return true;
    }

    // PATRÓN 3: Mezcla anormal de mayúsculas y minúsculas (>40% mayúsculas en texto largo)
    const upperCaseCount = (cleanText.match(/[A-Z]/g) || []).length;
    if (letterCount > 10 && upperCaseCount / letterCount > 0.4) {
      return true;
    }

    // PATRÓN 4: Muy pocas vocales en relación a consonantes (<20% vocales)
    const vowelCount = (cleanText.match(/[aeiouáéíóúAEIOUÁÉÍÓÚ]/g) || [])
      .length;
    if (letterCount > 6 && vowelCount / letterCount < 0.2) {
      return true;
    }

    return false;
  }

  // Detectar emails sospechosos
  private isSuspiciousEmail(email: string): boolean {
    if (!email || email.trim().length === 0) {
      return false;
    }

    // Lista de dominios temporales/desechables comunes
    const disposableDomains = [
      'tempmail.com',
      'guerrillamail.com',
      '10minutemail.com',
      'mailinator.com',
      'throwaway.email',
      'temp-mail.org',
    ];

    const domain = email.split('@')[1]?.toLowerCase();
    if (domain && disposableDomains.includes(domain)) {
      return true;
    }

    // Detectar múltiples puntos consecutivos en el email
    if (email.includes('..')) {
      return true;
    }

    return false;
  }
}
